<template>
	<v-container fluid class="pa-4">
		<v-row>
			<v-col cols="12">
				<v-card flat>
					<v-card-title class="d-flex align-center">
						<span>Notifiche</span>
						<v-spacer></v-spacer>
						<v-btn text small color="primary" @click="markAllRead" v-if="notifications.length">
							<v-icon left small>mdi-check-all</v-icon>
							Segna tutte come lette
						</v-btn>
					</v-card-title>
					<v-divider></v-divider>

					<v-list v-if="notifications.length" two-line>
						<template v-for="(notif, i) in notifications">
							<v-list-item
								:key="notif.id"
								:class="{ 'blue lighten-5': !notif.read_at }"
								@click="markRead(notif)"
							>
								<v-list-item-avatar>
									<v-icon :color="getTypeColor(notif.type)">{{ getTypeIcon(notif.type) }}</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title :class="{ 'font-weight-bold': !notif.read_at }">
										{{ notif.title }}
									</v-list-item-title>
									<v-list-item-subtitle>{{ notif.body }}</v-list-item-subtitle>
								</v-list-item-content>
								<v-list-item-action>
									<v-list-item-action-text>{{ formatDate(notif.created_at) }}</v-list-item-action-text>
									<v-icon v-if="!notif.read_at" small color="blue">mdi-circle</v-icon>
								</v-list-item-action>
							</v-list-item>
							<v-divider :key="'d-' + i" v-if="i < notifications.length - 1"></v-divider>
						</template>
					</v-list>

					<v-card-text v-else-if="!loading" class="text-center pa-12">
						<v-icon size="64" color="grey lighten-2">mdi-bell-off</v-icon>
						<div class="text-h6 grey--text mt-4">Nessuna notifica</div>
					</v-card-text>

					<v-card-text v-if="loading" class="text-center">
						<v-progress-circular indeterminate color="primary"></v-progress-circular>
					</v-card-text>

					<!-- Paginazione -->
					<v-card-actions v-if="total > rowsPerPage" class="justify-center">
						<v-pagination v-model="page" :length="Math.ceil(total / rowsPerPage)" @input="loadNotifications"></v-pagination>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'PortalNotifications',
	data() {
		return {
			notifications: [],
			loading: false,
			page: 1,
			rowsPerPage: 20,
			total: 0
		}
	},
	created() {
		this.loadNotifications()
	},
	methods: {
		async loadNotifications() {
			this.loading = true
			try {
				const resp = await this.axios.get('portal/notifications', {
					params: { page: this.page, rowsPerPage: this.rowsPerPage }
				})
				if (resp.data.success) {
					this.notifications = resp.data.data || []
					this.total = resp.data.total || 0
				}
			} catch (e) {
				// silenzioso
			} finally {
				this.loading = false
			}
		},
		async markRead(notif) {
			if (notif.read_at) return
			try {
				await this.axios.put('portal/notifications/' + notif.id + '/read')
				notif.read_at = new Date().toISOString()
				this.$store.dispatch('PORTAL_FETCH_UNREAD')
			} catch (e) {
				// silenzioso
			}
		},
		async markAllRead() {
			try {
				await this.axios.put('portal/notifications/read-all')
				this.notifications.forEach(n => {
					if (!n.read_at) n.read_at = new Date().toISOString()
				})
				this.$store.dispatch('PORTAL_FETCH_UNREAD')
			} catch (e) {
				// silenzioso
			}
		},
		formatDate(date) {
			if (!date) return ''
			return new Date(date).toLocaleDateString('it-IT', {
				day: '2-digit', month: '2-digit', year: 'numeric',
				hour: '2-digit', minute: '2-digit'
			})
		},
		getTypeIcon(type) {
			const map = {
				document_uploaded: 'mdi-file-upload',
				folder_created: 'mdi-folder-plus',
				access_granted: 'mdi-account-check',
				document_expiring: 'mdi-calendar-alert',
				document_expired: 'mdi-calendar-remove'
			}
			return map[type] || 'mdi-bell'
		},
		getTypeColor(type) {
			const map = {
				document_uploaded: 'green',
				folder_created: 'amber',
				access_granted: 'blue',
				document_expiring: 'orange',
				document_expired: 'red'
			}
			return map[type] || 'grey'
		}
	}
}
</script>
